/**
 * Lista degli errori da ignorare in Rollbar.
 * Il matching avviene su:
 *   - message {string} – sottostringa cercata in payload.body.trace.exception.message
 *   - key     {string} – "filename:lineno:colno" dell'ultimo frame sorgente
 *
 * Se key è presente, l'errore viene ignorato solo se ENTRAMBI coincidono.
 * Se key è assente, basta il match sul message.
 */
const rollbarIgnoredErrors = [
  {
    message: "Cannot read properties of null (reading 'value')",
    key: '../../src/javascript/packs/epersonam/components/print_fluid_balance_report.js',
  },
  // FIXED: null check aggiunto in behaviors/components/store_document.js (qs() guard)
  // {
  //   message: "Cannot read properties of null (reading 'addEventListener')",
  //   key: '../../src/javascript/packs/epersonam/components/store_document.js',
  // },
  {
    message: "null is not an object (evaluating 'xe.value')",
    key: '../../src/javascript/packs/epersonam/components/print_fluid_balance_report.js',
  },
  { message: 't.addEventListener is not a function', key: '../../src/javascript/packs/epersonam/components/ulFilterUtils.js' },
  {
    message: "Can't find variable: BroadcastChannel",
    key: '../../src/javascript/epersonam/views/domestics/sub_activities_config.js',
  },
  {
    message: "Cannot read properties of null (reading 'map')",
    key: '../../src/javascript/packs/epersonam/components/get_single_vmd_chart.js',
  },
  {
    message: "Cannot read properties of null (reading 'addEventListener')",
    key: '../../src/javascript/epersonam/views/business_units/edit.js',
  },
  {
    message: "Cannot read properties of null (reading 'length')",
    key: '../../src/javascript/epersonam/components/guestActivityPlan/guestActivityPlanForm.vue',
  },
  {
    message:
      't.addEventListener is not a function. (In \'t.addEventListener("input",r=>{const _e=r.target.value.toLowerCase(),Se=e.querySelectorAll("li");!Se.length||Se.forEach(xe=>{const ke=xe.textContent.toLowerCase();xe.style.display=ke.includes(_e)?"list-item":"none"})})\', \'t.addEventListener\' is undefined)',
    key: '../../src/javascript/packs/epersonam/components/ulFilterUtils.js',
  },
  { message: 'disableAfterSave is not defined', key: 'https://www.e-personam.com/it/mails/7888899' },
  { message: '$ is not defined', key: '../../src/javascript/epersonam/multiapp.js' },
  // FIXED: null check aggiunto in behaviors/components/store_document.js (qs() guard)
  // {
  //   message: "null is not an object (evaluating 'document.querySelector(t).addEventListener')",
  //   key: '../../src/javascript/packs/epersonam/components/store_document.js',
  // },
  {
    message: 'can\'t access property "value", xe is null',
    key: '../../src/javascript/packs/epersonam/components/print_fluid_balance_report.js',
  },
  { message: 'Network Error', key: '../../node_modules/axios/lib/adapters/xhr.js' },
  { message: 'Request failed with status code 422', key: '../../node_modules/axios/lib/core/settle.js' },
  { message: 'Request failed with status code 500', key: '../../node_modules/axios/lib/core/settle.js' },
  { message: 'Script error.', key: '(unknown)' },
  {
    message: 'redeclaration of non-configurable global property s',
    key: 'moz-extension://f67b93d0-2f5c-443b-affa-cda9173c38cb/features/ui.js',
  },
  // FIXED: null check aggiunto in behaviors/components/store_document.js (qs() guard)
  // {
  //   message: 'can\'t access property "addEventListener", document.querySelector(...) is null',
  //   key: '../../src/javascript/packs/epersonam/components/store_document.js',
  // },
  {
    message: "Failed to execute 'observe' on 'MutationObserver': parameter 1 is not of type 'Node'.",
    key: '../../src/javascript/packs/epersonam/views/guest/guest.js',
  },
  {
    message: "Cannot read property 'value' of null",
    key: '../../src/javascript/packs/epersonam/components/print_fluid_balance_report.js',
  },
  {
    message: "Cannot read properties of null (reading 'click')",
    key: '../../src/javascript/packs/epersonam/components/modify_all_gap.js',
  },
  { message: "Can't find variable: disableAfterSave", key: 'https://www.e-personam.com/it/22334/home' },
  // FIXED: null check spostato prima di .dataset in behaviors/components/guest_tab.js
  // {
  //   message: "Cannot read properties of null (reading 'dataset')",
  //   key: '../../src/javascript/packs/epersonam/components/guest_tab.js',
  // },
  {
    message: "Cannot read properties of undefined (reading 'id')",
    key: '../../src/javascript/epersonam/components/guestActivityPlan/guestActivityPlanForm.vue',
  },
  { message: 'xe is null', key: '../../src/javascript/packs/epersonam/components/print_fluid_balance_report.js' },
  // FIXED: :javascript FascicoloVisualizzatore.init() sostituito con behavior_trigger in browser.html.haml
  // { message: 'FascicoloVisualizzatore is not defined', key: 'https://www.e-personam.com/it/guest_period_data_sets/1212630/browser' },
  {
    message: "Cannot read properties of null (reading 'getAttribute')",
    key: '../../src/javascript/packs/epersonam/views/domestics/agenda.js',
  },
  { message: 'Request failed with status code 500', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  { message: 'eventBus is not defined', key: '../../src/javascript/epersonam/NotificationService/jobSupervisor.js' },
  { message: 'eventBus is not defined', key: '../../src/javascript/epersonam/globalScope.js' },
  {
    message: "Cannot read properties of undefined (reading '$emit')",
    key: '../../src/javascript/packs/epersonam/components/create_select2.js',
  },
  {
    message: 'CalendarFormModal is not defined',
    key: 'https://www.e-personam.com/it/guest_period_data_sets/968310/guest_activities',
  },
  { message: 'e0m is not defined', key: '(unknown)' },
  { message: 'Request failed with status code 500', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  { message: 'Request failed with status code 504', key: '../../node_modules/axios/lib/core/settle.js' },
  {
    message: "Cannot read properties of undefined (reading 'level0')",
    key: '../../src/javascript/epersonam/components/adv_components/navbar.vue',
  },
  { message: 'Request failed with status code 504', key: '../../node_modules/axios/lib/core/settle.js' },
  { message: "Argument 1 ('target') to MutationObserver.observe must be an instance of Node", key: '[native code]' },
  {
    message: "Cannot read properties of null (reading 'addEventListener')",
    key: '../../src/javascript/packs/epersonam/views/parameters_configs/parameters_partial/domiciliare.js',
  },
  { message: 'Request failed with status code 404', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  { message: 'JSON.parse(...) is null', key: '../../src/javascript/packs/epersonam/components/get_single_vmd_chart.js' },
  {
    message: "undefined is not an object (evaluating 'this.activityOptionsRaw.length')",
    key: '../../src/javascript/epersonam/components/guestActivityPlan/guestActivityPlanForm.vue',
  },
  {
    message: "Cannot read properties of undefined (reading 'checked')",
    key: '../../src/javascript/packs/epersonam/components/grp_activities.js',
  },
  // FIXED: null check aggiunto in behaviors/components/store_document.js (qs() guard)
  // { message: 'document.querySelector(...) is null', key: '../../src/javascript/packs/epersonam/components/store_document.js' },
  { message: 'Request failed with status code 502', key: '../../node_modules/axios/lib/core/settle.js' },
  {
    message: 'can\'t access property "level0", t is undefined',
    key: '../../src/javascript/epersonam/components/adv_components/navbar.vue',
  },
  {
    message: "null is not an object (evaluating 'document.querySelector(t).addEventListener')",
    key: '../../src/javascript/epersonam/views/guest_valutations/valutationPrintUpdate.js',
  },
  { message: "Can't find variable: moment", key: '../../src/javascript/epersonam/globalScope.js' },
  { message: 'this.obj.select2 is not a function', key: '../../src/javascript/packs/epersonam/components/create_select2.js' },
  {
    message: "undefined is not a function (near '...t.addEventListener...')",
    key: '../../src/javascript/packs/epersonam/components/ulFilterUtils.js',
  },
  { message: 'Request failed with status code 520', key: '../../node_modules/axios/lib/core/settle.js' },
  { message: 'Request aborted', key: '../../node_modules/axios/lib/adapters/xhr.js' },
  { message: 'moment is not defined', key: '../../src/javascript/epersonam/globalScope.js' },
  { message: '$(...).modal is not a function', key: '../../src/javascript/epersonam/components/pais/modalTeam.vue' },
  {
    message: "null is not an object (evaluating 'xe.value')",
    key: '../../src/javascript/epersonam/views/domestics/sub_activities_config.js',
  },
  {
    message: 'can\'t access property "map", JSON.parse(...) is null',
    key: '../../src/javascript/packs/epersonam/components/get_single_vmd_chart.js',
  },
  { message: 'Request failed with status code 502', key: '../../node_modules/axios/lib/helpers/parseHeaders.js' },
  {
    message: 'null is not an object (evaluating \'document.querySelector("*[data-fse-activator=normal]").addEventListener\')',
    key: '../../src/javascript/epersonam/views/business_units/edit.js',
  },
  {
    message: 'can\'t access property "addEventListener", document.querySelector(...) is null',
    key: '../../src/javascript/epersonam/views/business_units/edit.js',
  },
  { message: 'Request failed with status code 401', key: '../../node_modules/axios/lib/core/settle.js' },
  {
    message: "null is not an object (evaluating 'Ie.click')",
    key: '../../src/javascript/packs/epersonam/components/modify_all_gap.js',
  },
  { message: 'Request failed with status code 401', key: '../../node_modules/axios/lib/helpers/parseHeaders.js' },
  {
    message: "undefined is not a function (near '...t.addEventListener...')",
    key: '../../src/javascript/epersonam/views/guest_valutations/valutationPrintUpdate.js',
  },
  { message: 'Failed to fetch', key: '../../src/javascript/packs/epersonam/views/menu_reports/cot_reports.js' },
  { message: 'Network Error', key: '../../node_modules/axios/lib/adapters/xhr.js' },
  { message: 'Ie is null', key: '../../src/javascript/packs/epersonam/components/modify_all_gap.js' },
  { message: "Identifier 'd' has already been declared", key: "SyntaxError: Identifier 'd' has already been declared" },
  // FIXED: :javascript filePreview.init() sostituito con behavior_trigger in HAML
  // { message: 'filePreview is not defined', key: 'https://www.e-personam.com/it/business_units/5050/documents' },
  {
    message: "null is not an object (evaluating 'JSON.parse(r).map')",
    key: '../../src/javascript/packs/epersonam/components/get_single_vmd_chart.js',
  },
  {
    message: 'GuestValutationCopy is not defined',
    key: 'https://www.e-personam.com/it/guest_period_data_sets/312787/guest_menu_valutation/menu',
  },
  { message: 'Request failed with status code 500', key: '../../node_modules/axios/lib/core/settle.js' },
  { message: 'Network Error', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  { message: 'GuestDataValidation is not defined', key: 'https://www.e-personam.com/it/guest_period_data_sets/1195332/residential' },
  { message: 'moment is not defined', key: '../../src/javascript/epersonam/NotificationService/jobSupervisor.js' },
  { message: 'timeout exceeded', key: '../../node_modules/axios/lib/adapters/xhr.js' },
  // FIXED: null check spostato prima di .dataset in behaviors/components/guest_tab.js
  // { message: 'e is null', key: '../../src/javascript/packs/epersonam/components/guest_tab.js' },
  { message: 'Request failed with status code 422', key: '../../node_modules/axios/lib/core/settle.js' },
  { message: 'Network Error', key: '../../node_modules/axios/lib/helpers/parseHeaders.js' },
  // FIXED: null check spostato prima di .dataset in behaviors/components/guest_tab.js
  // { message: "null is not an object (evaluating 'e.dataset')", key: '../../src/javascript/packs/epersonam/components/guest_tab.js' },
  {
    message: "_e.sort is not a function. (In '_e.sort((Se,xe)=>xe.cod.toUpperCase()>Se.cod.toUpperCase()?-1:1)', '_e.sort' is undefined)",
    key: '../../node_modules/html-to-image/es/embed-webfonts.js',
  },
  {
    message: "Cannot read properties of undefined (reading 'level0')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.116.0/assets/navbar.930ca290.js',
  },
  {
    message: 'can\'t access property "getAttribute", document.getElementById(...) is null',
    key: '../../src/javascript/packs/epersonam/views/domestics/agenda.js',
  },
  {
    message: "Cannot read properties of null (reading 'value')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.116.0/assets/main.425cdc29.js',
  },
  {
    message: "Cannot read properties of undefined (reading 'description')",
    key: '../../src/javascript/epersonam/components/guestActivityPlan/guestActivityPlanForm.vue',
  },
  {
    message: 'null is not an object (evaluating \'document.getElementById("guest_activity_domestic_activities_config_id").getAttribute\')',
    key: '../../src/javascript/packs/epersonam/views/domestics/agenda.js',
  },
  { message: 'Request failed with status code 404', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  {
    message: "Can't find variable: valutationPrintUpdate",
    key: 'https://www.e-personam.com/it/guest_period_data_sets/1191650/pais/2010835',
  },
  { message: 'LdapUsernameValidation is not defined', key: 'https://www.e-personam.com/users/password/new' },
  {
    message: 'PrintFluidBalanceReport is not defined',
    key: 'https://www.e-personam.com/it/guest_period_data_sets/976212/guest_measurements',
  },
  {
    message: 'Retries exceeded',
    key: 'chrome-extension://iohjgamcilhbgmhbnllfolmkmmekfmci/injected-scripts/host-additional-hooks.js',
  },
  {
    message: 'Retries exceeded',
    key: 'chrome-extension://iohjgamcilhbgmhbnllfolmkmmekfmci/injected-scripts/host-network-events.js',
  },
  {
    message: 'Retries exceeded',
    key: 'chrome-extension://iohjgamcilhbgmhbnllfolmkmmekfmci/injected-scripts/host-console-events.js',
  },
  { message: 'Retries exceeded', key: 'chrome-extension://iohjgamcilhbgmhbnllfolmkmmekfmci/injected-scripts/host-dom-snapshot.js' },
  { message: 'Request failed with status code 504', key: '../../node_modules/axios/lib/helpers/parseHeaders.js' },
  {
    message: "this.obj.select2 is not a function. (In 'this.obj.select2(this.options)', 'this.obj.select2' is undefined)",
    key: '../../src/javascript/packs/epersonam/components/create_select2.js',
  },
  {
    message: "Cannot read properties of undefined (reading 'level0')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.115.0/assets/navbar.ee954195.js',
  },
  {
    message: "Cannot read properties of null (reading 'value')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.115.0/assets/main.83bb9efc.js',
  },
  {
    message: "Cannot read properties of null (reading 'value')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.114.1/assets/main.9920bcf3.js',
  },
  { message: 'Request failed with status code 409', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  {
    message: "Cannot read properties of undefined (reading 'level0')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.114.0/assets/navbar.024ef141.js',
  },
  {
    message: "Cannot read properties of null (reading 'value')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.114.0/assets/main.da4fe275.js',
  },
  {
    message: "Cannot read properties of undefined (reading 'data')",
    key: 'https://cdn-acare.e-personam.com/ext/select2/v4.0.5/select2.full.min.js',
  },
  {
    message: 'valutationPrintUpdate is not defined',
    key: 'https://www.e-personam.com/it/guest_period_data_sets/35885/pais/1997456/edit',
  },
  { message: 'StickyTitleNav is not defined', key: 'https://www.e-personam.com/it/guest_period_data_sets/35885/pais/1997456/edit' },
  {
    message: "null is not an object (evaluating 't.addEventListener')",
    key: '../../src/javascript/packs/epersonam/views/parameters_configs/parameters_partial/domiciliare.js',
  },
  { message: 'Invalid time value', key: '../../node_modules/date-fns/esm/format/index.js' },
  {
    message: 'can\'t access property "description", r is undefined',
    key: '../../src/javascript/epersonam/components/guestActivityPlan/guestActivityPlanForm.vue',
  },
  {
    message: 'can\'t access property "length", this.activityOptionsRaw is null',
    key: '../../src/javascript/epersonam/components/guestActivityPlan/guestActivityPlanForm.vue',
  },
  { message: 'eventBus is not defined', key: '../../src/javascript/packs/epersonam/components/protection_control.js' },
  // FIXED: :javascript GuestTab.init() sostituito con behavior_trigger in guests/edit e guests/show
  // { message: 'GuestTab is not defined', key: 'https://www.e-personam.com/it/guest_period_data_sets/1198431/guests/806653/edit' },
  {
    message: 'Guest.init is not a function',
    key: 'https://www.e-personam.com/it/guest_period_data_sets/1198431/guests/806653/edit',
  },
  { message: 'can\'t access property "click", Ie is null', key: '../../src/javascript/packs/epersonam/components/modify_all_gap.js' },
  {
    message: "Cannot read properties of undefined (reading 'level0')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.113.1/assets/navbar.b64932e8.js',
  },
  { message: 'Request failed with status code 409', key: '../../node_modules/epersonam-notification-client/dist/index.js' },
  {
    message: 'Select2SelectAll is not defined',
    key: 'https://www.e-personam.com/it/guest_period_data_sets/1121011/guest_menu_valutation/menu',
  },
  { message: 't is null', key: '../../src/javascript/packs/epersonam/views/parameters_configs/parameters_partial/domiciliare.js' },
  { message: 'CalendarFormModal is not defined', key: 'https://www.e-personam.com/it/domestic/agenda' },
  { message: 'Request failed with status code 504', key: '../../node_modules/axios/lib/core/AxiosError.js' },
  {
    message: "Cannot read properties of null (reading 'classList')",
    key: '../../src/javascript/packs/epersonam/views/domestics/adi_sgdt_dom.js',
  },
  {
    message: "null is not an object (evaluating 'xe.value')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.113.1/assets/main.909b963f.js',
  },
  {
    message: "null is not an object (evaluating 'r.document')",
    key: '../../src/javascript/epersonam/components/users/exceededUsersLimitCount.vue',
  },
  // FIXED: :javascript filePreview.init() sostituito con behavior_trigger in documents/index
  // { message: 'filePreview is not defined', key: 'https://www.e-personam.com/it/guest_period_data_sets/1200109/documents' },
  { message: 'timeout exceeded', key: '../../node_modules/axios/lib/helpers/parseHeaders.js' },
  {
    message: 'can\'t access property "$emit", window.eventBus is undefined',
    key: '../../src/javascript/packs/epersonam/components/create_select2.js',
  },
  {
    message: "Cannot read properties of null (reading 'getAttribute')",
    key: '../../src/javascript/epersonam/components/adv_components/navbar.vue',
  },
  {
    message: 'a.toLowerCase is not a function',
    key: 'https://cdn-acare.e-personam.com/ext/moment-with-locale/v2.15.2/moment-with-locales.min.js',
  },
  { message: 'Request failed with status code 500', key: '../../node_modules/axios/lib/helpers/parseHeaders.js' },
  // FIXED: :javascript FascicoloVisualizzatore.init() sostituito con behavior_trigger in browser.html.haml
  // {
  //   message: "Can't find variable: FascicoloVisualizzatore",
  //   key: 'https://www.e-personam.com/it/guest_period_data_sets/1159136/browser',
  // },
  {
    message: 'Script error.',
    key: 'https://cdn2.e-personam.com/assets/application-ea12281003009e151de1eb1ee0d6a7ce5bf4ab9d6fc69d2c3e65e56fb995e63d.js',
  },
  { message: 'Timeout', key: 'chrome-extension://iohjgamcilhbgmhbnllfolmkmmekfmci/injected-scripts/host-additional-hooks.js' },
  {
    message: 'tabId not found',
    key: 'chrome-extension://iohjgamcilhbgmhbnllfolmkmmekfmci/injected-scripts/host-additional-hooks.js',
  },
  { message: 'The string did not match the expected pattern.', key: '[native code]' },
  {
    message: "Cannot read properties of undefined (reading 'level0')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.113.0/assets/navbar.c27a8d24.js',
  },
  {
    message: "Cannot read properties of null (reading 'value')",
    key: 'https://cdn-acare.e-personam.com/cartella-frontend/v7.113.0/assets/main.0892f160.js',
  },
];

export default rollbarIgnoredErrors;
